const shadow = {
  'level-1': '0px  1px  4px -1px rgba(0, 0, 0, 0.32)',
  'level-2': '0px  1px  8px      rgba(0, 0, 0, 0.18)',
  'level-3': '0px  3px 16px      rgba(0, 0, 0, 0.1)',
  'level-4': '0px 11px 32px      rgba(0, 0, 0, 0.1)',
  'level-5': '0px 15px 40px      rgba(0, 0, 0, 0.12)',
}

module.exports = shadow
